import axios from 'axios'

export const state = {
  credentials: {
    firstname: '',
    lastname: '',
    fathername: '',
    email: '',
    phone: ''
  },
  agreements: [],
  error: '',
  phoneRaw: ''
}

export const actions = {
  getProfile({ commit }) {
    return new Promise(resolve => {
      axios.get('profile').then(promise => {
        commit('SET_PROFILE', promise.data.results)
        resolve()
      })
    })
  },
  updateProfile({ commit }, { credentials, uid }) {
    return new Promise(resolve => {
      axios
        .post('registration/register', {
          uid: uid,
          firstname: credentials.firstname,
          lastname: credentials.lastname,
          middlename: credentials.middlename,
          email: credentials.email,
          phone: credentials.phone
        })
        .then(promise => {
          resolve()
        })
    })
  }
}

export const getters = {
  // getMaskedPhone:
}

export const mutations = {
  SET_PROFILE(state, profile) {
    state.agreements = profile.agreements
    delete profile.agreements
    state.credentials = profile
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
